import { Tooltip } from "../ui/tooltip";
import { Icon } from "@chakra-ui/react";
import useIcons from "../../hooks/useIcons";
import { useBreakPoint } from "../../hooks/useBreakPoint";
import { useState } from "react";

interface Props {
  content: string;
}

const Info = ({ content }: Props) => {
  const [open, setOpen] = useState(false);
  const icons = useIcons();
  const { isMobile } = useBreakPoint();
  return (
    <Tooltip
      open={isMobile ? open : undefined}
      content={content}
      positioning={{ placement: "top" }}
      openDelay={0}
    >
      <Icon onClick={() => setOpen(!open)} as={icons.utility.info} />
    </Tooltip>
  );
};

export default Info;
